/* tslint:disable */
/* eslint-disable */
/**
 * CipherMail back-end API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { KeyServerSubmitDetails } from '../model';
// @ts-ignore
import type { PGPKeyServerClientSettings } from '../model';
// @ts-ignore
import type { PGPKeyServerDownloadResult } from '../model';
// @ts-ignore
import type { PGPKeyServerSearchResult } from '../model';
/**
 * PGPKeyServerClientApi - axios parameter creator
 * @export
 */
export const PGPKeyServerClientApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {boolean} autoTrust 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPKeyServerClientControllerDownloadKeys: async (autoTrust: boolean, requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'autoTrust' is not null or undefined
            assertParamExists('pGPKeyServerClientControllerDownloadKeys', 'autoTrust', autoTrust)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('pGPKeyServerClientControllerDownloadKeys', 'requestBody', requestBody)
            const localVarPath = `/api/pgp/keyserver/downloadKeys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (autoTrust !== undefined) {
                localVarQueryParameter['autoTrust'] = autoTrust;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPKeyServerClientControllerGetPGPKeyServers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/pgp/keyserver/getPGPKeyServers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPKeyServerClientControllerRefreshKeys: async (requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('pGPKeyServerClientControllerRefreshKeys', 'requestBody', requestBody)
            const localVarPath = `/api/pgp/keyserver/refreshKeys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} query 
         * @param {boolean} exactMatch 
         * @param {number} [maxKeys] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPKeyServerClientControllerSearchKeys: async (query: string, exactMatch: boolean, maxKeys?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('pGPKeyServerClientControllerSearchKeys', 'query', query)
            // verify required parameter 'exactMatch' is not null or undefined
            assertParamExists('pGPKeyServerClientControllerSearchKeys', 'exactMatch', exactMatch)
            const localVarPath = `/api/pgp/keyserver/searchKeys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (exactMatch !== undefined) {
                localVarQueryParameter['exactMatch'] = exactMatch;
            }

            if (maxKeys !== undefined) {
                localVarQueryParameter['maxKeys'] = maxKeys;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<PGPKeyServerClientSettings>} pGPKeyServerClientSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPKeyServerClientControllerSetPGPKeyServers: async (pGPKeyServerClientSettings: Array<PGPKeyServerClientSettings>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pGPKeyServerClientSettings' is not null or undefined
            assertParamExists('pGPKeyServerClientControllerSetPGPKeyServers', 'pGPKeyServerClientSettings', pGPKeyServerClientSettings)
            const localVarPath = `/api/pgp/keyserver/setPGPKeyServers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pGPKeyServerClientSettings, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPKeyServerClientControllerSubmitKeys: async (requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('pGPKeyServerClientControllerSubmitKeys', 'requestBody', requestBody)
            const localVarPath = `/api/pgp/keyserver/submitKeys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PGPKeyServerClientApi - functional programming interface
 * @export
 */
export const PGPKeyServerClientApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PGPKeyServerClientApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {boolean} autoTrust 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pGPKeyServerClientControllerDownloadKeys(autoTrust: boolean, requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PGPKeyServerDownloadResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pGPKeyServerClientControllerDownloadKeys(autoTrust, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PGPKeyServerClientApi.pGPKeyServerClientControllerDownloadKeys']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pGPKeyServerClientControllerGetPGPKeyServers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PGPKeyServerClientSettings>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pGPKeyServerClientControllerGetPGPKeyServers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PGPKeyServerClientApi.pGPKeyServerClientControllerGetPGPKeyServers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pGPKeyServerClientControllerRefreshKeys(requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PGPKeyServerDownloadResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pGPKeyServerClientControllerRefreshKeys(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PGPKeyServerClientApi.pGPKeyServerClientControllerRefreshKeys']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} query 
         * @param {boolean} exactMatch 
         * @param {number} [maxKeys] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pGPKeyServerClientControllerSearchKeys(query: string, exactMatch: boolean, maxKeys?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PGPKeyServerSearchResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pGPKeyServerClientControllerSearchKeys(query, exactMatch, maxKeys, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PGPKeyServerClientApi.pGPKeyServerClientControllerSearchKeys']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<PGPKeyServerClientSettings>} pGPKeyServerClientSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pGPKeyServerClientControllerSetPGPKeyServers(pGPKeyServerClientSettings: Array<PGPKeyServerClientSettings>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pGPKeyServerClientControllerSetPGPKeyServers(pGPKeyServerClientSettings, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PGPKeyServerClientApi.pGPKeyServerClientControllerSetPGPKeyServers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pGPKeyServerClientControllerSubmitKeys(requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KeyServerSubmitDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pGPKeyServerClientControllerSubmitKeys(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PGPKeyServerClientApi.pGPKeyServerClientControllerSubmitKeys']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PGPKeyServerClientApi - factory interface
 * @export
 */
export const PGPKeyServerClientApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PGPKeyServerClientApiFp(configuration)
    return {
        /**
         * 
         * @param {boolean} autoTrust 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPKeyServerClientControllerDownloadKeys(autoTrust: boolean, requestBody: Array<string>, options?: any): AxiosPromise<PGPKeyServerDownloadResult> {
            return localVarFp.pGPKeyServerClientControllerDownloadKeys(autoTrust, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPKeyServerClientControllerGetPGPKeyServers(options?: any): AxiosPromise<Array<PGPKeyServerClientSettings>> {
            return localVarFp.pGPKeyServerClientControllerGetPGPKeyServers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPKeyServerClientControllerRefreshKeys(requestBody: Array<string>, options?: any): AxiosPromise<PGPKeyServerDownloadResult> {
            return localVarFp.pGPKeyServerClientControllerRefreshKeys(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} query 
         * @param {boolean} exactMatch 
         * @param {number} [maxKeys] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPKeyServerClientControllerSearchKeys(query: string, exactMatch: boolean, maxKeys?: number, options?: any): AxiosPromise<PGPKeyServerSearchResult> {
            return localVarFp.pGPKeyServerClientControllerSearchKeys(query, exactMatch, maxKeys, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<PGPKeyServerClientSettings>} pGPKeyServerClientSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPKeyServerClientControllerSetPGPKeyServers(pGPKeyServerClientSettings: Array<PGPKeyServerClientSettings>, options?: any): AxiosPromise<void> {
            return localVarFp.pGPKeyServerClientControllerSetPGPKeyServers(pGPKeyServerClientSettings, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPKeyServerClientControllerSubmitKeys(requestBody: Array<string>, options?: any): AxiosPromise<KeyServerSubmitDetails> {
            return localVarFp.pGPKeyServerClientControllerSubmitKeys(requestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PGPKeyServerClientApi - object-oriented interface
 * @export
 * @class PGPKeyServerClientApi
 * @extends {BaseAPI}
 */
export class PGPKeyServerClientApi extends BaseAPI {
    /**
     * 
     * @param {boolean} autoTrust 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGPKeyServerClientApi
     */
    public pGPKeyServerClientControllerDownloadKeys(autoTrust: boolean, requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return PGPKeyServerClientApiFp(this.configuration).pGPKeyServerClientControllerDownloadKeys(autoTrust, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGPKeyServerClientApi
     */
    public pGPKeyServerClientControllerGetPGPKeyServers(options?: RawAxiosRequestConfig) {
        return PGPKeyServerClientApiFp(this.configuration).pGPKeyServerClientControllerGetPGPKeyServers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGPKeyServerClientApi
     */
    public pGPKeyServerClientControllerRefreshKeys(requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return PGPKeyServerClientApiFp(this.configuration).pGPKeyServerClientControllerRefreshKeys(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} query 
     * @param {boolean} exactMatch 
     * @param {number} [maxKeys] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGPKeyServerClientApi
     */
    public pGPKeyServerClientControllerSearchKeys(query: string, exactMatch: boolean, maxKeys?: number, options?: RawAxiosRequestConfig) {
        return PGPKeyServerClientApiFp(this.configuration).pGPKeyServerClientControllerSearchKeys(query, exactMatch, maxKeys, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<PGPKeyServerClientSettings>} pGPKeyServerClientSettings 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGPKeyServerClientApi
     */
    public pGPKeyServerClientControllerSetPGPKeyServers(pGPKeyServerClientSettings: Array<PGPKeyServerClientSettings>, options?: RawAxiosRequestConfig) {
        return PGPKeyServerClientApiFp(this.configuration).pGPKeyServerClientControllerSetPGPKeyServers(pGPKeyServerClientSettings, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGPKeyServerClientApi
     */
    public pGPKeyServerClientControllerSubmitKeys(requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return PGPKeyServerClientApiFp(this.configuration).pGPKeyServerClientControllerSubmitKeys(requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}

